export default "__VITE_ASSET__ByYUm7mQ__"